import Vue, { createApp } from 'vue'

import store from './store/index'
import { Amplify, Auth, API, Logger } from 'aws-amplify'
import mitt from 'mitt'
import VueNextSelect from 'vue-next-select'
import VueMobileDetection from 'vue-mobile-detection'
import PrimeVue from 'primevue/config'
import DialogService from 'primevue/dialogservice'
import StyleClass from 'primevue/styleclass'
import Tooltip from 'primevue/tooltip'
import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primeflex/primeflex.css'
import ToastService from 'primevue/toastservice'
import { i18n } from '@/plugins/i18n'
import App from './App.vue'
import cookieconfig from './plugins/cookies'
import awsconfig from './aws-exports'
import { initFacebookSdk, jwtInterceptor, fakeBackend } from './_helpers'

import router from './router'
import { useDevice } from './utils/useDevice'
;/ eslint-disable /

fakeBackend()
// enable interceptors for http requests
jwtInterceptor()
// wait for facebook sdk to start app
initFacebookSdk().then(createApp)

let output = {}
output = jsonConcat(output, awsconfig)
output = jsonConcat(output, cookieconfig)

Amplify.configure(output)

// Deshabilitar el botón de retroceso del navegador
// history.pushState(null, null, location.href)
// window.onpopstate = function () {
// 	history.go(1)
// }

router.beforeEach((to, from, next) => {
	const localStorageLang = localStorage.getItem('language')
	if (!localStorageLang) localStorage.setItem('language', 'en')

	const locale = to.params.locale ? to.params.locale : localStorageLang

	const supportedLocales = ['en', 'es', 'ar', 'jp', 'zh', 'pt', 'ko']

	i18n.locale = locale

	const urlWithoutLocale = to.path.replace(`/${to.params.locale}`, '')

	// Check if the current path starts with a valid locale
	if (supportedLocales.includes(to.params.locale)) {
		next() // If the URL already has a valid locale, proceed as normal
	} else {
		// If no valid locale, prepend the locale to the path
		next({
			path: `/${locale}${urlWithoutLocale}`,
			query: to.query,
			hash: to.hash,
		})
	}
})

Logger.LOG_LEVEL = 'ERROR'

const emitter = mitt()
const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)
app.use(Auth)
app.use(API)
app.use(VueMobileDetection)
app.use(PrimeVue)

app.use(DialogService)
app.directive('tooltip', Tooltip)
app.directive('styleclass', StyleClass)
app.use(ToastService)
app.component('VueSelect', VueNextSelect)

app.config.devtools = false

app.config.errorHandler = () => null
app.config.warnHandler = () => null

app.config.globalProperties.emitter = emitter
app.config.globalProperties.$useDevice = useDevice
app.mount('#app')

function jsonConcat(o1, o2) {
	for (const key in o2) {
		o1[key] = o2[key]
	}
	return o1
}
